export enum REQUEST_STATUS {
  IDLE = "idle",
  ERROR = "error",
  PENDING = "pending",
  SUCCESS = "success"
}
